<template>
  <div class="first-step-component">
    <food-window
      v-if="showFoodWindow"
      @close="closeFoodWindow"
      :item="currentFoodItem"
    />

    <section v-show="!showFoodWindow && !showPromotionsWindow">
      <food-categories />
      <v-loader v-show="isLoadingCategories" absolute />
      <v-row v-if="menuItems.length" class="menu-items">
        <v-loader v-show="isLoading" absolute />
        <v-col v-for="item in computedMenuItems" :key="item.id" sm="4" xl="3">
          <food-card
            :item="item"
            @openFoodWindow="openFoodWindow"
            new
            bonus
            child
          />
        </v-col>
      </v-row>
      <span v-else class="d-block display-3 text-center">Ничего не найдено</span>
    </section>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import FoodCategories from './food-categories/FoodCategories'
  import FoodCard from '@/components/order-processing/order-components/first-step/FoodCard'
  import FoodWindow from '@/components/order-processing/order-components/first-step/FoodWindow'

  export default {
    name: 'FirstStep',
    components: {
      VLoader,
      FoodCategories,
      FoodCard,
      FoodWindow,
    },
    data () {
      return {
        currentFoodItem: {},
      }
    },
    computed: {
      ...mapState({
        showFoodWindow: state => state.fastOrder.showFoodWindow,
        showPromotionsWindow: (state) => state.fastOrder.showPromotionsWindow,
        isLoading: (state) => state.fastOrder.isMenuItemsLoading,
        menuItems: (state) => state.fastOrder.menuItemsList || [],
        isLoadingCategories: state => state.categories.isLoading,
        searchMenu: state => state.fastOrder.searchMenu,
      }),
      ...mapGetters({
        allMenuItems: 'fastOrder/getAllMenuItems',
      }),
      computedMenuItems () {
        if (this.searchMenu) {
          return this.allMenuItems.filter(item => {
            const itemName = item.name.toLowerCase()
            const searchString = this.searchMenu.toLowerCase()
            return itemName.includes(searchString)
          })
        }
        return this.menuItems
      },
    },
    methods: {
      openFoodWindow (item) {
        this.currentFoodItem = item
      },
      closeFoodWindow () {
        this.$store.commit('fastOrder/setFoodWindowState', false)
      },
    },
    beforeDestroy () {
      this.closeFoodWindow()
    },
  }
</script>

<style lang="less" scoped>
.first-step-component {
  background-color: transparent;

  .menu-items {
    position: relative;
    z-index: 0;
  }
}
</style>
